import api, { armorAPI } from '~/services/api';
import { JSONTransaction } from '~/types/Transaction';

function get(transactionObjectId: string) {
  return api.request<JSONTransaction>({
    url: `/transactions/${transactionObjectId}`,
    method: 'GET',
  });
}

function emailNotify(transactionObjectIds: string[]) {
  return armorAPI.request({
    url: '/email',
    method: 'POST',
    data: {
      transactions: transactionObjectIds,
    },
  });
}

function refund(transactionObjectId: string) {
  return api.request({
    url: `refunds/`,
    method: 'POST',
    data: {
      transaction: transactionObjectId,
    },
  });
}

export { get, emailNotify, refund };
